import { useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "./components/Header";
import ErrorBoundary from "./components/ErrorBoundary";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import DevisSection from "./components/DevisSection";
import ProtectionSection from "./components/ProtectionSection";
import AccessoriesSection from "./components/AccessoriesSection";
import ShowcaseSection from "./components/ShowcaseSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import MobileCTA from "./components/MobileCTA";
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/CGV";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import ReparationIphone from "./pages/services/ReparationIphone";
import ReparationEcranIphone from "./pages/services/ReparationEcranIphone";
import ChangementBatterieIphone from "./pages/services/ChangementBatterieIphone";
import ReparationSamsung from "./pages/services/ReparationSamsung";
import ReparationEcranSamsung from "./pages/services/ReparationEcranSamsung";
import MicroSoudure from "./pages/services/MicroSoudure";
import { WIX_REDIRECTS } from "./pages/WixRedirects";
import CookieBanner from "./components/CookieBanner";
import { Toaster } from "./components/ui/sonner";

const HomeWithScroll = ({ section }) => {
  const navigate = useNavigate();
  useEffect(() => {
    try { sessionStorage.setItem('allorep:scrollTo', section); } catch {}
    navigate('/', { replace: true });
  }, [navigate, section]);
  return null;
};

const Home = () => {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  const initialScrollHandled = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowMobileCTA(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (initialScrollHandled.current) return;
    initialScrollHandled.current = true;

    let target = null;
    try { target = sessionStorage.getItem('allorep:scrollTo'); } catch {}
    if (!target) {
      window.scrollTo(0, 0);
      return;
    }
    try { sessionStorage.removeItem('allorep:scrollTo'); } catch {}

    const scrollToTarget = () => {
      const el = document.querySelector(target);
      if (el) el.scrollIntoView({ behavior: 'instant', block: 'start' });
    };

    setTimeout(scrollToTarget, 100);
    setTimeout(scrollToTarget, 700);
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ServicesSection />
        <DevisSection />
        <section id="produits">
          <ProtectionSection />
          <AccessoriesSection />
        </section>
        <ShowcaseSection />
        <TestimonialsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <WhatsAppButton />
      {showMobileCTA && <MobileCTA />}
    </>
  );
};

function App() {
  const location = useLocation();
  return (
    <div className="App min-h-screen bg-white">
      <ErrorBoundary locationKey={location.pathname}>
        <Routes>
        <Route path="/" element={<Home />} />
        {/* Pages de service SEO (multi-pages) */}
        <Route path="/reparation-iphone-montpellier" element={<ReparationIphone />} />
        <Route path="/reparation-ecran-iphone-montpellier" element={<ReparationEcranIphone />} />
        <Route path="/changement-batterie-iphone-montpellier" element={<ChangementBatterieIphone />} />
        <Route path="/reparation-samsung-montpellier" element={<ReparationSamsung />} />
        <Route path="/reparation-ecran-samsung-montpellier" element={<ReparationEcranSamsung />} />
        <Route path="/micro-soudure-montpellier" element={<MicroSoudure />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/cgv" element={<CGV />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        {WIX_REDIRECTS.map(({ from, to }) => {
          const isHashRedirect = to.startsWith('/#');
          return (
            <Route
              key={from}
              path={from}
              element={
                isHashRedirect
                  ? <HomeWithScroll section={to.slice(1)} />
                  : <Navigate to={to} replace />
              }
            />
          );
        })}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ErrorBoundary>
      <CookieBanner />
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
